import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Ornament from "@/components/Ornament";
import { api } from "@/lib/config";
import { formatUKDate } from "@/lib/date";
import { ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <>
        <Navigation />
        <section className="max-w-3xl mx-auto px-6 py-32 text-center">
          <h1 className="press-title text-4xl text-ink">This page is missing.</h1>
          <Link to="/diary" className="inline-block mt-8 text-burgundy underline underline-offset-4">Return to the diary</Link>
        </section>
        <Footer />
      </>
    );
  }

  if (!post) return (
    <>
      <Navigation />
      <section className="max-w-3xl mx-auto px-6 py-32 text-center font-serif text-ink/60">Loading…</section>
    </>
  );

  return (
    <>
      <Navigation />
      <article className="max-w-3xl mx-auto px-6 md:px-8 pt-16 md:pt-24 pb-24" data-testid="blog-post">
        <Link to="/diary" className="inline-flex items-center gap-2 font-sans text-[0.7rem] uppercase tracking-[0.22em] text-ink/60 hover:text-burgundy" data-testid="back-to-journal">
          <ArrowLeft className="w-3 h-3" strokeWidth={1.5} /> back to the diary
        </Link>
        <div className="eyebrow mt-10">{formatUKDate(post.published_at)}</div>
        <h1 className="press-title text-4xl md:text-6xl text-ink mt-4 leading-[1.05]">{post.title}</h1>
        <p className="font-display italic text-xl md:text-2xl text-ink/75 mt-4">{post.excerpt}</p>
        <Ornament />
        {post.cover_video ? (
          <video
            src={post.cover_video}
            className="w-full aspect-[16/9] object-cover my-10"
            controls
            playsInline
            preload="metadata"
          />
        ) : (
          <img src={post.cover_image} alt={post.title} className="w-full aspect-[16/9] object-cover my-10" />
        )}
        <div className="font-serif text-lg leading-[1.8] text-ink/85 space-y-6">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i} className={i === 0 ? "drop-cap" : ""}>{para}</p>
          ))}
        </div>
      </article>
      <Footer />
    </>
  );
}
